import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/common/site-ttl.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "home-loading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "home-loading__inner" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "num" }),
    /*#__PURE__*/_createElementVNode("div", { class: "bar" }, [
      /*#__PURE__*/_createElementVNode("span")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "home__ttl-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "home__ttl" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "home__txt" }, [
    /*#__PURE__*/_createTextVNode("HEBITSUKAI'S ILLUSTRATION "),
    /*#__PURE__*/_createElementVNode("br", { class: "u-sp-only" }),
    /*#__PURE__*/_createTextVNode("PORTFOLIOS")
  ])
], -1)
const _hoisted_3 = { class: "home__img" }
const _hoisted_4 = { class: "home__img-box" }
const _hoisted_5 = { class: "home__img-subbox" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "home__news" }, [
  /*#__PURE__*/_createElementVNode("p", null, "2022.03.19 UPDATED")
], -1)
const _hoisted_8 = { class: "u-pc-only" }
const _hoisted_9 = { class: "home__btn-list" }
const _hoisted_10 = { class: "home__btn home__btn--about" }
const _hoisted_11 = { class: "home__btn home__btn--contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", {'is--loaded': _ctx.isLoaded}])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pickups, (p, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: p,
            ref: 'li'+index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: '/works/detail/'+p.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: '/img/illust/'+p.year + '/' + p.id.split('-')[1] +'/main.png',
                      alt: "",
                      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loaded && _ctx.loaded(...args)))
                    }, null, 40, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ], 512))
        }), 128))
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Btn, {
            layout: "left",
            url: "/about",
            text: "ABOUT"
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Btn, {
            layout: "right",
            url: "/works/2022",
            text: "WORKS"
          })
        ])
      ])
    ])
  ], 2))
}